import {useRouter} from 'next/router';

/** Forwarded to express/upgrade via `SubscriptionCTA` `subscriptionCheckoutEntry`. */
export const SUBSCRIPTION_CHECKOUT_ENTRY_QUERY_PARAM = 'subscription_checkout_entry';

/**
 * Value of `subscription_checkout_entry` on the current page (e.g. org-growth → Personal Plan LP).
 */
export function useSubscriptionCheckoutEntryParam(): string | undefined {
    const router = useRouter();
    const raw = router.query[SUBSCRIPTION_CHECKOUT_ENTRY_QUERY_PARAM];
    if (raw === undefined) {
        return undefined;
    }
    const value = Array.isArray(raw) ? raw[0] : raw;
    return typeof value === 'string' && value.length > 0 ? value : undefined;
}
